/**
 * Outils de langue de donoor.org (chantier multilingue 2026-10-10 :
 * fr/en/de/es/it/nl ; anglais sous /en/..., allemand sous /de/..., etc.,
 * cf. i18n/pagesTraduites.ts).
 */

/** Langues proposées. Le français est la langue par défaut (sans préfixe). */
export const LANGUES = ["fr", "en", "de", "es", "it", "nl"] as const;
export type Langue = (typeof LANGUES)[number];

/** Locale Intl de chaque langue (dates, montants). */
export const LOCALE_INTL: Record<Langue, string> = {
  fr: "fr-FR",
  en: "en-GB",
  de: "de-DE",
  es: "es-ES",
  it: "it-IT",
  nl: "nl-NL",
};

/** Nom natif de chaque langue, pour le sélecteur. */
export const NOM_LANGUE: Record<Langue, string> = {
  fr: "Français",
  en: "English",
  de: "Deutsch",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
};

/** Cookie du choix explicite de langue (sélecteur), 1 an. */
export const COOKIE_LANGUE = "donoor_langue";

export function estLangue(valeur: unknown): valeur is Langue {
  return typeof valeur === "string" && (LANGUES as readonly string[]).includes(valeur);
}

/**
 * Chemin sans le préfixe de langue : « /de/a/ma-collecte » → « /a/ma-collecte »,
 * « /de » → « / ». Un chemin français (sans préfixe) est rendu tel quel.
 *
 * À utiliser pour TOUTE comparaison de chemin (`startsWith("/c/")`…) : sans
 * lui, la version traduite d'une page ne serait pas reconnue.
 */
export function cheminSansLangue(chemin: string): string {
  const prefixe = LANGUES.find(
    (l) => l !== "fr" && (chemin === `/${l}` || chemin.startsWith(`/${l}/`) || chemin.startsWith(`/${l}?`) || chemin.startsWith(`/${l}#`)),
  );
  if (!prefixe) return chemin;
  const reste = chemin.slice(1 + prefixe.length);
  if (reste === "") return "/";
  return reste.startsWith("/") ? reste : `/${reste}`;
}

/** Langue portée par un chemin (« /de/... » → de, sinon fr). */
export function langueDuChemin(chemin: string): Langue {
  const prefixe = LANGUES.find(
    (l) => l !== "fr" && (chemin === `/${l}` || new RegExp(`^/${l}[/?#]`).test(chemin)),
  );
  return prefixe ?? "fr";
}
